export default __webpack_public_path__ + "static/media/6.c9c7e92e.jpg";